import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import rmsActions from "../../../../actions/rmsActions";
import { getPDPs, getRmsAppCode, isFetching } from "../../../../reducers";
import { DataTypes } from "../../../../constants";

import ThisTheme from "../../../../themes/PORTTheme";

import BlankCard from "../../../Common/Card/BlankCard";
import PDPsCard from "./PDPsCard";
import PORTErrorCard from "../PORTErrorCard";


const MyPDPsCard = () => {
    const pdps = useSelector((state) => getPDPs(state));
    const isFetchingStatus = useSelector((state) => isFetching(state, DataTypes.PDPS));
    const dispatch = useDispatch();
    const appCode = useSelector(getRmsAppCode);

    useEffect(() => {
        if (!!appCode) {
            dispatch(rmsActions.getPDPs(appCode));
        }
    }, [dispatch, appCode]);

    if (isFetchingStatus) return <BlankCard />;

    return pdps ? (
        <PDPsCard data={pdps} theme={ThisTheme} />
    ) : (
        <PORTErrorCard
            resource="pdp"
            title="PDPs"
            error="No data available"
            message="An error occurred while trying to connect the portfolio service."
        />
    );
};

export default MyPDPsCard;
